import { showToastOnApiCall } from "../utils/utils";
import { downloadPdf } from "./use-download-pdf";
import { useSnackbar } from "./useSnackbar";

type BlobContentType =
  | "application/zip"
  | "application/pdf"
  | "text/csv"
  | "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

type UseDownloadReportOptions = {
  onSuccess?: (fileURL: string) => void;
  shouldDownload?: boolean
};

type DownloadCall = {
  apiCall: Promise<any>;
  fileName: string;
  contentType?: BlobContentType;
};

/**
 * @description  Generic component To clean up the code for report download
 * 
 * @returns download :(apiCall)=>void
 */
export function useDownloadReport({
  onSuccess, shouldDownload = true
}: UseDownloadReportOptions = {}) {
  const showSnackbar = useSnackbar();

  const download = async ({
    apiCall,
    fileName,
    contentType = "application/pdf",
  }: DownloadCall) => {
    showToastOnApiCall({
      showSnackbar,
      apiCall: apiCall,
      onSave: (res: any) => {
        const blob = new Blob([res?.data], { type: contentType });
        if (shouldDownload)
          downloadPdf(blob, fileName);
        showSnackbar({"type":"success",message:`${fileName.split(".")[1]} file successfully downloaded`})
        const fileUrl = URL.createObjectURL(blob);
        onSuccess?.(fileUrl);
      },
    });
  };

  return { download };
}
